import { render, staticRenderFns } from "./RoleBasedAccessControlMenu.vue?vue&type=template&id=c7d496ce&scoped=true"
import script from "./RoleBasedAccessControlMenu.vue?vue&type=script&lang=js"
export * from "./RoleBasedAccessControlMenu.vue?vue&type=script&lang=js"
import style0 from "./RoleBasedAccessControlMenu.vue?vue&type=style&index=0&id=c7d496ce&prod&scoped=true&lang=scss"
import style1 from "./RoleBasedAccessControlMenu.vue?vue&type=style&index=1&id=c7d496ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d496ce",
  null
  
)

export default component.exports